"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useStudioFeatureSettings } from "@/features/dashboard/hooks/useStudioFeatureSettings";
import { useAuth } from "@/lib/contexts";
import { setActiveRoleApiHeader } from "@/lib/utils/api/active-role-header";
import { resolveVisibleActiveRole } from "@/lib/utils/roles";

/** Keeps API writes tagged with the role currently switched on. */
export function ActiveRoleApiHeader() {
  const user = useAuth();
  const pathname = usePathname();
  const { choreographerPortalEnabled, isPending } = useStudioFeatureSettings();
  const visibleRole = resolveVisibleActiveRole(
    user,
    choreographerPortalEnabled,
    !isPending,
  );

  useEffect(() => {
    const role = pathname?.startsWith("/portal") ? null : visibleRole;
    setActiveRoleApiHeader(role);
    return () => setActiveRoleApiHeader(null);
  }, [pathname, visibleRole]);

  return null;
}
